<template>
<div>    
    <v-container fluid class="primary header pa-0">
        <v-container grid-list-xl style="max-width:1170px" >
        <v-layout row wrap class="mb-5">
            <v-flex xs12 md3 class="mt-2">
                <img src="http://www.globaltrademag.com/wp-content/uploads/2019/06/gt_connect_logo_accent.png" class="platform-logo mt-2 mb-4">
                <br>
            </v-flex>
            <v-flex xs12 md7 class="mt-2 pr-5">
                <h1 class="main-title my-0" style="font-size:2.3em;">Searching For The Right Provider?</h1>
                <h2 style="color:#eee; font-size:1.85em!important; font-family:'Arial', sans-serif; font-weight:bold" class="my-0">
                    Discover Providers That Can Help You Today<br>
                </h2>
                <p class="font-weight-medium mb-1 mt-2 header-paragraph">
                    There are hundreds of providers you can consider based on location,<br>services and provider type.Start your search to explore options for a brighter future:
                </p>     
                <v-btn dark color="#100429" class="ml-0" @click="learnMore = true">Learn More</v-btn>
                <v-btn dark color="#100429" class="ml-0" href="http://www.globaltrademag.com/gtconnect-advertiser/#/signup">Free Provider Listing</v-btn>           
                <learn-more v-if="learnMore" v-model="learnMore"></learn-more>
            </v-flex>
        </v-layout>
    </v-container>
    </v-container>
    <v-container class="pa-0" v-if="$store.state.categoriesLoaded&&$store.state.associationsLoaded" style="max-width:1170px">
        <v-layout row wrap>
            <v-flex xs12 md12 class="carousel-flex pa-0">
                <carousel :perPageCustom="[[360, 2.5], [1024, 6]]" :navigationEnabled="true" :paginationEnabled="false" :autoplay="true" :autoplayTimeout="2000">
                    <slide v-for="(category, name, index) in $store.state.categories" :key="name" v-if="category.categoryFeatureOnPlatform&&category.disabled!==true">                  
                        <featured-category-card  :category="category" :category-key="name" 
                        v-model="selectedCategory"
                        />                        
                    </slide>
                </carousel>
            </v-flex>
        </v-layout>
    </v-container>

    <v-container  v-if="!loading&&$store.state.categoriesLoaded"  grid-list-xl style="max-width:1170px; margin-bottom:120px">
        <v-layout row wrap>
            <v-flex xs12 md9>
                <v-layout row wrap v-if="!selectedCategory">
                    <v-flex xs12>
                        <h2 class="my-3" style="font-size:1.9em">Today's Featured Listings</h2>
                    </v-flex>
                </v-layout>

                <v-slide-x-transition group tag="div" class="layout row wrap" hide-on-leave v-if="!selectedCategory">
                    <v-flex xs12 md4 v-for="(listing, name, index) in listings" :key="name" 
                    v-if="listing.featured">
                        <listing-card v-on:add-request="requestAdded" v-on:remove-request="requestRemoved" :listing="listing" :listing-key="name"></listing-card>
                    </v-flex>
                </v-slide-x-transition>


                <v-layout row wrap v-if="selectedCategory&&(Object.values(listings).some(v=>{return (v.category==selectedCategory&&v.elite)}))" align-center>
                    <v-flex grow>
                        <h2 class="my-3">ELITE {{$store.state.categories[selectedCategory].categoryName}}</h2>
                    </v-flex>
                </v-layout>
            
                <v-slide-x-transition  v-if="selectedCategory" group tag="div" class="layout row wrap" hide-on-leave>
                    <v-flex xs12 md4 v-for="(listing, name, index) in listings" :key="name" 
                    v-if="(!selectedCategory || listing.category == selectedCategory)&&listing.elite===true">
                        <listing-card v-on:add-request="requestAdded" v-on:remove-request="requestRemoved" :listing="listing" :listing-key="name"></listing-card>
                    </v-flex>
                </v-slide-x-transition>

                <v-layout row wrap v-if="selectedCategory&&(Object.values(listings).some(v=>{return (v.category==selectedCategory&&v.requestButton)}))" align-center>
                    <v-flex grow>
                        <h2 class="my-3">Preferred {{$store.state.categories[selectedCategory].categoryName}}</h2>
                    </v-flex>
                </v-layout>
            
                <v-slide-x-transition  v-if="selectedCategory" group tag="div" class="layout row wrap" hide-on-leave>
                    <v-flex xs12 md4 v-for="(listing, name, index) in listings" :key="name" 
                    v-if="(!selectedCategory || listing.category == selectedCategory)&&listing.requestButton===true">
                        <listing-card v-on:add-request="requestAdded" v-on:remove-request="requestRemoved" :listing="listing" :listing-key="name"></listing-card>
                    </v-flex>
                </v-slide-x-transition>

                

                <v-divider class="mb-5" style="border-color:#aaa"></v-divider>

                <v-layout row wrap v-if="selectedCategory" align-center>
                    <v-flex grow>
                        <h2 class="my-3">OTHER  {{$store.state.categories[selectedCategory].categoryName}} YOU MAY WANT TO CONSIDER.</h2>
                    </v-flex>
                </v-layout>

                <v-slide-x-transition  v-if="selectedCategory" group tag="div" class="layout row wrap" hide-on-leave>
                    <v-flex xs12 md4 v-for="(listing, name, index) in listings" :key="name" 
                    v-if="(!selectedCategory || listing.category == selectedCategory)&&!listing.requestButton">
                        <listing-card v-on:add-request="requestAdded" v-on:remove-request="requestRemoved" :listing="listing" :listing-key="name"></listing-card>
                    </v-flex>
                </v-slide-x-transition>
            </v-flex>


            <v-flex xs12 md3 class="pt-5 mt-5">
                 <v-card class="mt-5 ml-4 text-xs-center pa-3" dark style="background-color:#100429; font-weight:bold; font-size:1.1em;" href="http://www.globaltrademag.com/gtconnect-advertiser/#/login"> 
                    Provider Login
                </v-card>

                <v-card class="mt-5 ml-4 py-3" style="background-color:#f6a027" href="http://www.globaltrademag.com/gtconnect-advertiser/#/signup"> 
                    <v-card-text>
                        <h2 style="font-size:1.8em; font-weight:normal; line-height:1.1em;text-align:center; font-family:'Roboto'; color:#fff">
                            Create Your<br><em style="font-style:normal; font-weight:bold">FREE</em><br>Provider Listing
                        </h2>
                    </v-card-text>
                    <v-card-media cover height="auto" src="http://www.globaltrademag.com/wp-content/uploads/2019/07/ad_icon-01.png">                        
                    </v-card-media>
                    <v-card-text>
                        <h4 class="mx-3" style="font-size:1.3em; font-weight:bold; line-height:1.2em;text-align:center;">
                            Find &amp; Meet New Prospects Today
                        </h4>
                    </v-card-text>
                </v-card>

                <v-card class="mt-5 ml-4 py-0" href="http://www.globaltrademag.com/gtconnect-front/#/listing/La_Plata_County_EDC/g5Rsi2oHlm7o4tMZuiAp"> 
                    <v-card-media cover height="auto" src="http://www.globaltrademag.com/wp-content/uploads/2019/07/2019-07-01.png"> </v-card-media>
                </v-card>

               
                
            </v-flex>
        </v-layout>
    </v-container>

    <v-footer app dark class="requests-footer px-5 py-3" style="height:auto!important" v-if="Object.keys(requests).length">
        <v-container style="max-width:1170px" class="pa-0">
            <v-layout row wrap align-center class="py-0" style="border:none!important">
            <h2 style="color:#fff">You have <em class="requests-number">{{Object.keys(requests).length}}</em> Pending Requests</h2>
            <v-spacer></v-spacer>
            <v-btn large light color="primary" @click="sending = true">Send Requests</v-btn>      
            </v-layout>             
        </v-container>            
    </v-footer>    

    <v-dialog v-model="sending" scrollable max-width="900px" :overlay="false" transition="dialog-transition">
        <v-stepper non-linear :value="currentStep" style="width:100%">
            <img src="http://www.globaltrademag.com/wp-content/uploads/2019/06/2019-06-19.png" style="width:100%" alt="">
            <v-stepper-header>
                <v-stepper-step step="1" editable :complete="currentStep>1">Choose Providers</v-stepper-step>
                
                <v-stepper-step step="2" editable :complete="currentStep>2">Describe Your Challenge</v-stepper-step>
                
                <v-stepper-step step="3" editable :complete="currentStep>3">Contact Information</v-stepper-step>
                
                <v-stepper-step step="4" editable :complete="currentStep>4">Complete Request</v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
                <v-stepper-content step="1">
                    <v-layout row wrap>
                        <v-flex xs12>
                            <h2>Confirm Chosen Providers</h2>
                        </v-flex>
                        <v-flex xs12 md6 px-3 v-for="(requestListing, name, index) in requests" :key="name"> 
                            <dialog-listing-item  v-on:add-request="requestAdded" v-on:remove-request="requestRemoved"  :listing="requestListing" :listing-key="name"></dialog-listing-item>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-spacer></v-spacer>
                        <v-flex xs12 md6 px-3>
                            <v-btn color="primary" :disabled="!Object.keys(requests).length" block @click="currentStep = 2">Next</v-btn>
                        </v-flex>
                    </v-layout>
                </v-stepper-content>
                
                <v-stepper-content step="2">
                    
                    <v-form>
                        <v-layout row wrap>
                            <v-flex xs12>
                                <h2>WHAT ARE YOU LOOKING FOR?</h2>
                            </v-flex>
                            <v-flex xs12 px-3><v-textarea v-model="challenge" class="fill-height-textarea" textarea label="Describe your challenge"></v-textarea></v-flex>
                        </v-layout>
                    </v-form>
                        <v-layout row wrap>
                        <v-spacer></v-spacer>
                        <v-flex xs12 md6 px-3>
                            <v-btn :disabled="challenge==''" color="primary" block @click="currentStep = 3">Next</v-btn>
                        </v-flex>
                    </v-layout>
                </v-stepper-content>
                
                <v-stepper-content step="3">
                    <v-form v-model="contactValid">
                        <v-layout row wrap align-baseline>
                            <v-flex xs12>
                                <h2>What's your best contact information?</h2>
                            </v-flex>                                
                            <v-flex xs12 md6 px-3><v-text-field label="Full Name" v-model="name" :rules="$rules.name"></v-text-field></v-flex>
                            <v-flex xs12 md6 px-3><v-text-field label="Email" v-model="email" :rules="$rules.email"></v-text-field></v-flex>
                            <v-flex xs12 md6 px-3><v-text-field label="Company Name" v-model="company" :rules="$rules.company"></v-text-field></v-flex>
                            <v-flex xs12 md6 px-3><v-text-field label="Phone Number" v-model="phone" :rules="$rules.phone"></v-text-field></v-flex>
                            <v-flex xs12 md6 px-3><v-text-field label="Zip Code" v-model="zip" :rules="$rules.zip"></v-text-field></v-flex>
                            <v-flex xs12 md6 px-3>
                                <v-btn color="primary" :disabled="!contactValid" block @click="currentStep = 4">Next</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-form>
                </v-stepper-content>

                <v-stepper-content step="4">
                    <v-layout row wrap>
                        <v-flex xs12>
                            <h2>Last Step!</h2>
                            <p>Please let us know what type of information you would like to receive</p>
                        </v-flex>
                        <v-flex xs12 md6 px-3>
                            <p class="mt-3">We never, EVER share or sell your information, email or phone number, to anyone other than the specific businesses you have requested. By submitting this form, you agree to receive text messages from Global Trade Magazine and the businesses you've requested more information from. View our  <a href="#" @click="terms = true">Terms</a> and <a href="#" @click="privacy = true">Privacy Policy</a>.</p>
                        </v-flex>
                        <v-flex xs12 md6 px-3>
                            <v-switch color="primary" v-model="quotes" label="Free Information"></v-switch>
                            <v-switch color="primary" v-model="information" label="Free Quotes"></v-switch>
                            <v-btn color="primary" block @click="sendRequests()">Submit your request</v-btn>
                        </v-flex>
                    </v-layout>
                </v-stepper-content>
            </v-stepper-items>

        </v-stepper>
    </v-dialog>

    <v-dialog v-model="sentSuccessfully" style="max-width:500px" max-width="500px" >
        <v-card class="text-xs-center pa-3">
            <h2 style="font-size:2.5em">HOLD ON TIGHT!</h2>
            <p class="font-weight-bold px-4">Thank you for your request! We are connecting you with top providers as we speak.</p>
            <img class="sent-animation mt-4" src="http://www.globaltrademag.com/wp-content/uploads/2019/06/fly.gif">
        </v-card>
    </v-dialog>

    <v-dialog max-width="500px" transition="dialog-transition" persistent v-model="thankyou">
        <v-card>
            <v-card-text class="pt-5 text-xs-center font-weight-bold">
                <img style="width:50%" src="https://lh3.googleusercontent.com/-N-d5sSClDoE/XQkrCGRplBI/AAAAAAAABQg/2M310Lq-jEsMVP6Ys673V2CqvaYN4k6uACK8BGAs/s0/2019-06-18.png" alt="">
                <h2 style="font-size:2.5em">Thank You!</h2>
                <p class="mt-3 px-4">We have sent your request directly to the providers alerting them to send the information you have requested.  Please allow 1 to 2 business days for them to process your request!</p>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="thankyou = false">Done</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <privacy-policy v-if="privacy" v-model="privacy"></privacy-policy>
    <terms v-if="terms" v-model="terms"></terms>
    
</div>
</template>

<script>
import firebase from '@/firebase.js';
import FeaturedCategoryCard from '@/components/items/FeaturedCategoryCard.vue';
import ListingCard from '@/components/items/ListingCard.vue';
import DialogListingItem from '@/components/items/DialogListingItem.vue';
import PrivacyPolicy from '@/components/PrivacyPolicy.vue';
import Terms from '@/components/Terms.vue';
import LearnMore from '@/components/LearnMore.vue';

export default {
    data() {
        return {
            listings:{},
            loading:true,
            selectedCategory:'',
            requests:{},
            sending:false,
            currentStep:0,

            contactValid:false,
            challenge:'',
            name:'',
            company:'',
            zip:'',
            email:'',
            phone:'',
            quotes:true,
            information:true,
            sentSuccessfully:false,
            thankyou:false,
            privacy:false,
            terms:false,
            learnMore:false,
        }
    },

    created() {
        this.$store.dispatch('getCategories');
        this.$store.dispatch('getAssociations');
        this.listAll();
    },

    methods: {
        listAll() {
            this.loading = true;
            firebase.firestore().collection('listings').where('approved', '==', true).get().then(snapshot=>{
                snapshot.forEach(listing=>{
                    this.listings[listing.id] = listing.data();
                });
                this.loading = false;
            });
        },

        requestAdded(key) {
            this.$set(this.requests, key, this.listings[key]);
        },
        requestRemoved(key) {
            this.$delete(this.requests, key);
        },

        sendRequests() {
            var requestsNumber = Object.keys(this.requests).length;
            var savedNumber = 0;
            Object.keys(this.requests).forEach(requestKey=>{
                var listing = this.requests[requestKey];
                var newRequest = {
                    date:Date.now(),
                    toUserId:listing.userId,
                    toUserEmail:listing.userEmail,
                    category:listing.category,
                    toCompanyName:listing.companyName,
                    fromName:this.name,
                    fromEmail:this.email,
                    fromCompany:this.company,
                    fromPhone:this.phone,
                    fromZip:this.zip,
                    challenge:this.challenge,
                    quotes:this.quotes,
                    information:this.information,
                    completed:false,
                    favorite:false
                }
                console.log(newRequest);
                firebase.firestore().collection('requests').add(newRequest).then(docref=>{
                    savedNumber++;
                    if (requestsNumber == savedNumber) {
                        this.currentStep = 0;
                        this.sending = false;
                        this.sentSuccessfully = true;
                        setTimeout(() => {
                            this.sentSuccessfully = false;
                            this.thankyou = true;
                            this.requests = {};
                            this.listings = {};
                            this.listAll();
                        }, 5000);  
                    }
                    console.log(docref.id);
                })
            });
        }
    },

    components:{FeaturedCategoryCard, ListingCard, DialogListingItem, PrivacyPolicy, Terms, LearnMore}
 }
</script>

<style>
    h1, h2, h3, h4 {
        font-family: 'Oswald', sans-serif;
    }

    .header {
        background-color: #f6b143;
        background-image: url('http://www.globaltrademag.com/wp-content/uploads/2019/06/header_background-01.png');
        background-position: 110% 50%;
        background-size: contain;
    }

    .requests-number {
        color: #f6b143;
        font-style: normal;
        font-style: bold;
        font-size: 1.2em;
    }

    .platform-logo {
        width: 90%;
    }

    .cta-phrase {
        font-size: 1.2em;
    }

    .sent-animation{
        filter: hue-rotate(194.5deg) saturate(229.2%);
        width: 100%;
    }

    .carousel-flex {
        margin-top: -90px;
        padding: 16px!important;
    }

    .VueCarousel-slide {
        padding: 7px;
    }

    .v-btn__content {
        font-weight: bold;
    }

    .theme--light > .v-btn__content{
        color: #100429;
    }

    .theme--dark > .v-btn__content{
        color:#f6b143;
    }


    .VueCarousel-navigation-button{
        background-color: #f6b143!important;
        color: #100429!important;
        width: 42px;
        height: 42px;
        border-radius: 50px;
        opacity: 1!important;
        text-align: center!important;
        box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.25);
        transform: translateY(-50%) translateX(-40%)!important;
        outline: none;
    }

    .VueCarousel-navigation-next{
        transform: translateY(-50%) translateX(40%)!important;
    }

    .requests-footer {
        background-color: #100429!important;
        z-index: 99;
    }

    .fill-height-textarea {
        height: 100%;
    }

    
    .fill-height-textarea .v-input__slot {
        height: 100%;
    }

    .fill-height-textarea .v-input__control {
        height: 100%;
    }


    .fill-height-textarea .v-text-field__slot {
        height: 100%;
    }

    .fill-height-textarea textarea {
        height: 100%;
    }

    @media (max-width: 768px) {
        .main-title {
            font-size: 1.2em;
            font-weight: 800;
        }

        .carousel-flex {
            margin-top: 0;
            padding: 0 0 0 16px !important;
        }

        .VueCarousel-navigation {
            display: none!important;
        }

        
        .header-paragraph {
            font-size: 0.95em;
            line-height: 1.2em
        }

        .platform-logo {
            width: 50%;
        }

        .header {
            background-color: #f6b143;
            background-image: none;
            background-position: 100% 50%;
            background-size: contain;
        }
    }
</style>
